let Util = function () {
  "ngInject";

  return {
    getSummernoteOptions: getSummernoteOptions
  }

  function getSummernoteOptions() {
    return {
      height: 300,
      focus: false,
      airMode: false,
      toolbar: [
        ['edit', ['undo', 'redo']],
        ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
        ['textsize', ['fontsize']],
        // ['fontclr', ['color']],
        ['alignment', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'hr', 'picture']],
        ['view', ['codeview']]
      ]
    }
  }

}
export default Util;



// WEBPACK FOOTER //
// ./client/app/services/utilService/util.service.js